import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { DoubleClickRecognizer } from '../../lib/DoubleClickRecognizer'
import { TriState, Platforms } from '../../actions/toolbar'

import { TriStateShifter, ClickEvent } from '../../lib/TriStateShifter'
import ToolbarButton from './ToolbarButton'

class KeyModifierComponent extends React.Component {
  constructor (props) {
    super(props)
    this._doubleClickRecognizer = new DoubleClickRecognizer(this.onSingleClick, this.onDoubleClick)
  }

  classNames = {
    [TriState.Active]: 'keyOn',
    [TriState.AlwaysOn]: 'keyAlwaysOn',
    [TriState.Inactive]: '',
    [Platforms.WINDOWS]: {
      Meta: 'keyWindows',
      Control: 'keyWindowsCtrl',
      Alt: 'keyWindowsAlt',
      Shift: 'keyWindowsShift',
    },
    [Platforms.MAC_OS]: {
      Meta: 'keyMac',
      Control: 'keyMacCtrl',
      Alt: 'keyMacAlt',
      Shift: 'keyMacShift',
    },
  }

  onSingleClick = () => {
    const currentState = this.props.state
    const newState = TriStateShifter.shiftState(currentState, ClickEvent.SingleClick)
    this.props.onStateChanged(currentState, newState)
  }

  onDoubleClick = () => {
    const currentState = this.props.state
    const newState = TriStateShifter.shiftState(currentState, ClickEvent.DoubleClick)
    this.props.onStateChanged(currentState, newState)
  }

  render () {
    const { id, state: buttonState, platform, disabled } = this.props
    const className =
      `${this.classNames[platform][id]} ${this.classNames[buttonState]} ${disabled ? 'disabled' : ''}`

    return (
      <ToolbarButton
        className={className}
        id={this.props.id}
        onClick={this._doubleClickRecognizer.click}
        disabled={disabled} >
      </ToolbarButton>
    )
  }
}

KeyModifierComponent.propTypes = {
  id: PropTypes.string.isRequired,
  state: PropTypes.number.isRequired,
  platform: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  onStateChanged: PropTypes.func.isRequired,
}

export function mapStateToProps () {
  return {}
}

export const KeyModifier = connect(
  mapStateToProps
)(KeyModifierComponent)
